import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ensureServerTimeSync,
  formatServerHeaderDateTime,
  getServerAdjustedNow,
  getServerTimeZone,
  subscribeServerTime,
} from '../utils/serverTime';

export {
  formatServerCompactDateTime,
  formatServerHeaderDateTime,
  getServerAdjustedNow,
  getServerTimeZone,
  ensureServerTimeSync,
  formatInServerTz,
  formatChartTimeBucket,
  pickChartTimePattern,
} from '../utils/serverTime';

/**
 * Reloj alineado a la hora local del servidor (no al TZ del navegador).
 * `compactLabel` → "Vie 07 Ago 26 · 18:49:55" (i18n).
 */
export function useServerLocalClock(opts?: { enabled?: boolean }): {
  now: Date;
  timeZone: string;
  compactLabel: string;
} {
  const enabled = opts?.enabled !== false;
  const { t } = useTranslation();
  const [, setTick] = useState(0);
  const [timeZone, setTimeZone] = useState(getServerTimeZone);

  useEffect(() => {
    if (!enabled) return;
    ensureServerTimeSync();
    const bump = () => {
      setTimeZone(getServerTimeZone());
      setTick((n) => n + 1);
    };
    const id = window.setInterval(() => {
      ensureServerTimeSync();
      bump();
    }, 1000);
    const unsub = subscribeServerTime(bump);
    const onVisible = () => {
      if (document.visibilityState === 'visible') bump();
    };
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('pageshow', onVisible);
    return () => {
      window.clearInterval(id);
      unsub();
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('pageshow', onVisible);
    };
  }, [enabled]);

  const now = getServerAdjustedNow();
  return {
    now,
    timeZone,
    compactLabel: enabled
      ? formatServerHeaderDateTime(now, timeZone, t)
      : '',
  };
}
